import Flex from 'components/Flex'
import SidebarPage from 'components/SidebarPage'
import Nav from 'modules/Nav/Container/index'
import Header from 'modules/Page/Components/Partials/Header'
import React, { useEffect } from 'react'
import styled from 'styled-components'
import { COLORS } from 'theme'

const BREAKPOINT = '999px'

const ContentWrapper = styled(Flex)`
  overflow-y: auto;
  border-radius: 10px;
  margin-bottom: 40px;
  box-shadow: 0px 4px 12px rgba(153, 153, 153, 0.35);
  border: 1px solid ${COLORS.PAGE_BORDER};
  &::-webkit-scrollbar {
    display: none;
  }
`
const PageWrapper = styled(Flex)`
  background: '#FFFFFF';
  flex-direction: column;
  height: 100vh;
  min-height: 100vh;
  flex-grow: 1;
  @media screen and (max-width: ${BREAKPOINT}) {
    padding: 0px;
    overflow-x: hidden;
    box-sizing: border-box;
  }
`

const Page = ({
  children,
  corporateDetails,
  corporateData,
  userData,
  getUserInfo,
  userRole,
  getUserRoles,
  signOut,
  getNotificationsList,
  notificationData,
  markNotificationReadApi,
  getUserPermissions,
  checkout,
  candidateInterviewDetails,
  getSingleCandidateInterviewDetails,
  getRoleMetrics,
  rolesMetrics,
  updateInterviewStatus,
  getRescheduleList,
  notifyReschedule,
  getCandidateDetails,
  candidateDetails,
  addCorporateBranch,
  getRoleRounds,
  roundItemList,
  setLoading,
  interViewerList,
  createInterview,
  driveId,
  roleId,
  driveInterViewerList,
  getDriveInterviewerList,
  driveData,
  getCandidateList,
  getInterViewLocation,
  interViewData,
  corporateLocationsList,
  getCorporateLocationsList,
  getGroupDiscussionList,
  groupList,
  getListOfCountries,
  getListOfStates,
  getListOfCities,
  listOfCountries,
  listOfStates,
  listOfCities,
  UpdateScheudle,
  getDriveRoleCandidatesList,
}) => {
  useEffect(() => {
    getUserInfo()
    getUserRoles()
    corporateDetails()
  }, [])

  useEffect(() => {
    if (
      userData?.role_id !== undefined ||
      userData?.admin_role_id !== undefined
    ) {
      getUserPermissions(userData?.admin_role_id)
    }
  }, [userData])
  return (
    <PageWrapper>
      <Header
        corporateData={corporateData}
        userData={userData || {}}
        userRole={userRole}
        getUserRoles={getUserRoles}
        getUserInfo={getUserInfo}
        signOut={signOut}
        getNotificationsList={getNotificationsList}
        notificationData={notificationData}
        markNotificationReadApi={markNotificationReadApi}
        checkout={checkout}
        getSingleCandidateInterviewDetails={getSingleCandidateInterviewDetails}
        candidateInterviewDetails={candidateInterviewDetails}
        getRoleMetrics={getRoleMetrics}
        rolesMetrics={rolesMetrics}
        updateInterviewStatus={updateInterviewStatus}
        getRescheduleList={getRescheduleList}
        notifyReschedule={notifyReschedule}
        getCandidateDetails={getCandidateDetails}
        candidateDetails={candidateDetails}
        getRoleRounds={getRoleRounds}
        roundItemList={roundItemList}
        setLoading={setLoading}
        getListOfCountries={getListOfCountries}
        getListOfStates={getListOfStates}
        getListOfCities={getListOfCities}
        listOfCountries={listOfCountries}
        listOfStates={listOfStates}
        listOfCities={listOfCities}
        addCorporateBranch={addCorporateBranch}
        interViewerList={interViewerList}
        createInterview={createInterview}
        driveId={driveId}
        roleId={roleId}
        driveInterViewerList={driveInterViewerList}
        getDriveInterviewerList={getDriveInterviewerList}
        driveData={driveData}
        getCandidateList={getCandidateList}
        getInterViewLocation={getInterViewLocation}
        interViewData={interViewData}
        corporateLocationsList={corporateLocationsList}
        getCorporateLocationsList={getCorporateLocationsList}
        getGroupDiscussionList={getGroupDiscussionList}
        groupList={groupList}
        UpdateScheudle={UpdateScheudle}
        getDriveRoleCandidatesList={getDriveRoleCandidatesList}
      />
      <Flex
        style={{
          overflow: 'hidden',
          position: 'fixed',
          top: '73px',
          width: '100%',
        }}
      >
        <Nav />
        <SidebarPage>
          <ContentWrapper column>{children}</ContentWrapper>
        </SidebarPage>
      </Flex>
    </PageWrapper>
  )
}
export default Page
